import React, { RefObject, useEffect, useRef } from "react";
import styled from "styled-components";
import useResizeObserver from "use-resize-observer/polyfilled";
import { DateRange } from "@sonder/ui/source/styled/components/DateRangePicker";
import { getTotalColumns } from "@sonder/ui/source/styled/components/ScheduleLayer/helpers";
import { colors } from "@sonder/ui/source/styled/theme";

const StyledScheduleTimeColumnsLayout = styled.div`
  height: 100%;
  position: absolute;
  width: 100%;
`;

const StyledScheduleTimeColumns = styled.canvas`
  height: 100%;
  position: relative;
  width: 100%;
`;

const drawLine = (
  context: CanvasRenderingContext2D,
  x: number,
  dashed: boolean,
) => {
  context.beginPath();
  context.setLineDash(dashed ? [4, 2] : []);
  context.moveTo(x, 0);
  context.lineTo(x, context.canvas.height);
  context.stroke();
};

// I'm gonna assume you pass start and end in hour ranges, you filthly animals <3.
interface ScheduleTimeColumnsProps extends DateRange {}

export const ScheduleTimeColumns = ({
  endAt,
  startAt,
}: ScheduleTimeColumnsProps) => {
  const cols = getTotalColumns({ endAt, startAt });
  const {
    ref: parentLayerRef,
    height: parentLayerHeight = 0,
    width: parentLayerWidth = 0,
  } = useResizeObserver();
  const canvasRef = useRef<HTMLCanvasElement>(null);
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const context = canvas.getContext("2d");
    if (!context) return;
    context.strokeStyle = colors.grayE;
    context.lineWidth = 1;
    // Redrawing Time!
    context.clearRect(0, 0, context.canvas.width, context.canvas.height);
    new Array(cols + 1)
      .fill(undefined)
      .map((x, i) =>
        drawLine(
          context,
          Math.floor((i / cols) * context.canvas.width),
          i % 4 !== 0,
        ),
      );
  }, [parentLayerHeight, parentLayerWidth]);
  return (
    <StyledScheduleTimeColumnsLayout
      ref={parentLayerRef as RefObject<HTMLDivElement>}
    >
      <StyledScheduleTimeColumns
        height={parentLayerHeight}
        ref={canvasRef}
        width={parentLayerWidth}
      />
    </StyledScheduleTimeColumnsLayout>
  );
};
